import React from "react";
import Title from "./../Title";

//Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";

const index = ({ theme, showMenu }) => {
  return (
    <div className={showMenu ? `blur container` : "container"}>
      <Title text={`Erro 404`} type={`SECTION`} theme={theme} />
      <p>Página não encontrada.</p>
    </div>
  );
};

index.propTypes = {
  theme: PropTypes.string.isRequired,
  showMenu: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  showMenu: state.theme.showMenu
});

export default connect(
  mapStateToProps,
  {}
)(index);
